"use client";

import { useRouter } from "next/navigation";
import { Crown, X } from "lucide-react";

import Popup from "@/common/components/Popup/Popup";
import styles from "./TrialEndedPopup.module.scss";

interface TrialEndedPopupProps {
  show: boolean;
  onClose: () => void;
}

export default function TrialEndedPopup({
  show,
  onClose,
}: TrialEndedPopupProps) {
  const router = useRouter();

  return (
    <Popup show={show} onClose={onClose}>
      <div className={styles.trialEndedContainer}>
        <button
          type="button"
          className={styles.closeButton}
          aria-label="Close"
          onClick={onClose}
        >
          <X size={16} />
        </button>

        <div className={styles.icon}>
          <Crown size={26} />
        </div>

        <h3 className={styles.title}>Your Trial Has Ended</h3>

        <p className={styles.description}>
          Upgrade your plan to continue using Romantic Horoscope, ask daily
          questions, and unlock partner detail changes.
        </p>

        <button
          type="button"
          className={styles.upgradeButton}
          onClick={() => {
            onClose();
            router.push("/daily-romantic-horoscope/plans");
          }}
        >
          Upgrade Plan
        </button>

        <button type="button" className={styles.laterButton} onClick={onClose}>
          Maybe Later
        </button>
      </div>
    </Popup>
  );
}
